import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

/** Twitter認証リンクを取得 */
export async function getTwitterAuthLink(callbackUrl) {
  const fn = httpsCallable(functions, 'getTwitterAuthLink');
  const { data } = await fn({ callbackUrl });
  return data;
}

/** Twitter認証情報を保存 */
export async function saveTwitterAuth(oauthToken, oauthVerifier) {
  const fn = httpsCallable(functions, 'saveTwitterAuth');
  await fn({
    oauthToken,
    oauthVerifier,
    oauthTokenSecret: sessionStorage.getItem('oauthTokenSecret'),
  });
}

/** 完走証ツイートを投稿 */
export async function tweetRec3(docId, tweet, postWithImage) {
  const fn = httpsCallable(functions, 'tweetRec3');
  const { data } = await fn({ docId, tweet, postWithImage });
  return data;
}
